import styled from "styled-components";
import { deviceDF } from "../../utils/breakPoints";
import { BLUE_RGB } from "../../utils/colorsTheme";

const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.dir ? `${props.dir}` : "row")};
  justify-content: ${(props) =>
    props.justify ? `${props.justify}` : "flex-end"};
  flex-wrap: wrap;

  @media ${deviceDF.tablet} {
    flex-direction: column;
  }
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 100%;
  font-weight: bold;
  padding: 7px 5px;
`;

const styles = () => ({
  thTable: {
    fontSize: ".875rem !important",
    fontWeight: "bold !important",
    color: BLUE_RGB,
  },
  mapButton: {
    position: "absolute",
  },
});

export { ColumnContainer, StatusContainer, styles };
